import React, { useEffect, useRef } from 'react';

// used to identify clicks outside a specific component, e.g. to trigger the closing of a modal
const useOutsideClick = (
  ref: React.MutableRefObject<HTMLElement | SVGSVGElement | undefined | null>,
  callback: () => void
) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (
        ref.current &&
        e.target instanceof Node &&
        !ref.current.contains(e.target)
      ) {
        callbackRef.current();
      }
    };

    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array - only set up once
};

export default useOutsideClick;
